export default __webpack_public_path__ + "static/media/formula-notes.8442347d.svg";